'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hudlLinkType = require('./hudl-link-type');

var _hudlLinkType2 = _interopRequireDefault(_hudlLinkType);

var _Annotation = require('../../shared/icons/Annotation');

var _Annotation2 = _interopRequireDefault(_Annotation);

var _Presentation = require('../../shared/icons/Presentation');

var _Presentation2 = _interopRequireDefault(_Presentation);

var _Uniform = require('../../Uniform');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HudlLink = function HudlLink(props) {
  switch (props.type) {
    case _hudlLinkType2.default.Annotation:
      return _react2.default.createElement(_Annotation2.default, null);
    case _hudlLinkType2.default.Exchange:
      return _react2.default.createElement(_Uniform.Icon, { type: 'exchanges', size: 'small' });
    case _hudlLinkType2.default.Highlight:
      return _react2.default.createElement(_Uniform.Icon, { type: 'highlights', size: 'small' });
    case _hudlLinkType2.default.Playbook:
      return _react2.default.createElement(_Uniform.Icon, { type: 'playtools', size: 'small' });
    case _hudlLinkType2.default.Playlist:
      return _react2.default.createElement(_Uniform.Icon, { type: 'playlist', size: 'small' });
    case _hudlLinkType2.default.Presentation:
      return _react2.default.createElement(_Presentation2.default, null);
    case _hudlLinkType2.default.Report:
      return _react2.default.createElement(_Uniform.Icon, { type: 'reports', size: 'small' });
    default:
      return _react2.default.createElement('span', null);
  }
};

HudlLink.propTypes = {
  type: _react2.default.PropTypes.oneOf(Object.keys(_hudlLinkType2.default).map(function (key) {
    return _hudlLinkType2.default[key];
  }))
};

exports.default = HudlLink;